import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

// Component
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Redux
import store from "./store/index";

// css
import "./index.css";

const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
